import styles from "./visao-section.module.css";
import VisaoImg from "../../../images/_finais/visao_image_compress.webp";

const VisaoSection = () => {
  return (
    <section className={styles.visao_section}>
      <div className={styles.visao_texts_div}>
        <div className={styles.title_div}>
          <h2 className={styles.visao_title}>VISÃO</h2>
          <span className={styles.line}></span>
        </div>
        <p className={styles.visao_text}>
          Ser referência de consultoria em Real-World Evidence (RWE) para a
          Indústria Farmacêutica e Instituições de Saúde, reconhecida pela
          excelência na comunicação científica, inovação nas análises de dados e
          impacto positivo nos sistemas de saúde do Brasil.
        </p>
      </div>
      <img
        className={styles.visao_img}
        src={VisaoImg}
        alt="Imagem sobre Visão."
        loading="lazy"
      />
    </section>
  );
};

export default VisaoSection;
